<template>
  <div
    :id="`selectOtherLabelModal-${id}`"
    tabindex="-1"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
  >
    <div class="relative p-4 w-full max-w-2xl h-full md:h-auto">
      <!-- Modal content -->
      <div class="relative p-4 bg-white rounded-lg shadow  sm:p-5">
        <!-- Modal header -->
        <div
          class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 "
        >
          <h3 class="text-lg font-semibold text-gray-900 ">
            {{ labels['TITLE_OTHER_CERTIFICATION'][lg] }}
          </h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
            :data-modal-toggle="`selectOtherLabelModal-${id}`"
          >
            <svg
              aria-hidden="true"
              class="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="sr-only"> {{ labels['LABEL_CLOSE'][lg] }}</span>
          </button>
        </div>
        <!-- Modal body -->
        <form action="#">
          <div class="grid gap-4 mb-4  ">
            <div>
              <label
                for="iso"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                {{ labels['LABEL_ISO_NAME'][lg] }}
              </label>

              <select
                id="iso"
                v-model="output.iso"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
              >
                <option
                  v-for="item in norms"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }} {{ item.id }}
                </option>
              </select>
            </div>
            <div>
              <label
                for="years"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                {{ labels['LABEL_ISO_YEAR'][lg] }}
              </label>
              <input
                v-if="output.iso && output.iso == 'other'"
                id="years"
                v-model="output.year"
                type="text"
                name="name"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                placeholder=""
              >


              <select
                v-if="output.iso && output.iso != 'other'"
                id="years"
                v-model="output.year"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
              >
                <option
                  v-for="year in years"
                  :key="year.id"
                  :value="year.id"
                >
                  {{ year.id }}
                </option>
              </select>
            </div>

            <div>
              <label
                for="prices"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                {{ labels['LABEL_COMPANY_ISO'][lg] }}
              </label>

              <input
                v-if="output.iso && output.iso == 'other'"
                id="name"
                v-model="output.company"
                type="text"
                name="name"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                placeholder=""
              >

              <select
                v-if="output.iso && output.iso != 'other'"
                id="company"
                v-model="output.company"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
                @change="onChangeCompany"
              >
                <option
                  v-for="company in companies"
                  :key="company.id"
                  :value="company.id"
                >
                  {{ company.name }}
                </option>
              </select>
            </div>
            <div class="sm:col-span-2">
              <div class="flex items-center justify-center w-full">
                <label
                  for="dropzone-file-document"
                  :class="{ 'opacity-50  ': isLoading }"
                  class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100   "
                >
                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <v-lazy-image
                      :id="`image-${id}`"
                      style="max-height:230px"
                      :class="{ 'opacity-50': isLoading }"
                      class="  transition duration-300 ease-in-out  block h-full w-full object-cover object-center"
                      :src="image"
                      :src-placeholder="image"
                      @load="onImgLoad(index)"
                    />
                  </div>
                </label>
                <div
                  v-if="isLoading"
                  role="status"
                  class="absolute   "
                >
                  <svg
                    aria-hidden="true"
                    class="w-8 h-8 mr-2 text-gray-200 animate-spin  fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span class="sr-only"> {{ labels['LABEL_LOADING'][lg] }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-end space-x-4">
            <button
              type="button"
              :data-modal-toggle="`selectOtherLabelModal-${id}`"
              class="text-gray-800 bg-primary-700   focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center   "
            >
              {{ labels['LABEL_BUTTON_CANCEL'][lg] }}
            </button>
            <button
              type="button"
              :data-modal-toggle="`selectOtherLabelModal-${id}`"
              class="text-white bg-gray-800 font-bold inline-flex items-center hover:text-white border     focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center     "
              @click="onValidate"
            >
              {{ labels['LABEL_BUTTON_VALIDATE'][lg] }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
    import labels from "@/assets/lg/products.json"
    import axios from "axios";
    import VLazyImage from "v-lazy-image";

    export default {
        name: 'ContentFileListModalPrices',
        components: { VLazyImage },
        props: {
            id: String
        },
        data() {
            return {
                isLoading: false,
                labels: labels,
                lg: "FR",
                output: {},
                empty: {},

                prices: [],
                image: "",
                companies: [

                    {

                        "id": "dekra",

                        "name": "DEKRA",
                        "images": {
                            "iso-22000": "http://localhost:3004/api/images/download/640dd7331f7126bfd3805fcd",
                            "iso-14001": "http://localhost:3004/api/images/download/640dd75e1f7126bfd3805fce"
                        }
                    }

                ],
                years: [
                    { id: "2023" },
                    { id: "2022" },
                    { id: "2021" },
                    { id: "2020" },
                    { id: "2019" },
                    { id: "2018" },
                    { id: "2017" },
                    { id: "2016" }
                ],
                norms: [

                    {
                        "id": "iso-22000",
                        "name": "ISO 22000",
                        "description": {
                            "EN": "",
                            "FR": "Système de management de la sécurité des denrées alimentaires"
                        }
                    },
                    {
                        "id": "iso-14001",
                        "name": "ISO 14001",
                        "description": {
                            "EN": "",
                            "FR": "Système de management environnemental"
                        }
                    },
                    {
                        "id": "other",
                        "name": "-",
                        "description": {
                            "EN": "",
                            "FR": ""
                        }
                    }

                ],


            }
        },
        mounted() {
            this.output.iso = this.norms[0].id;
            this.output.year = this.years[0].id;
            this.output.company = this.companies[0].id

        },
        methods: {

           // onImgLoad(){
       
           // },
            onChangeCompany() {
                //    let price = this.findPrice(this.output.competition, this.output.year, this.output.price)


                //  this.image = price.image
            },
            findNorm(id) {
                for (let i = 0; i < this.norms.length; i++) {
                    if (this.norms[i].id == id)
                        return this.norms[i]
                }
            },
            findCompany(id) {
                for (let i = 0; i < this.companies.length; i++) {
                    if (this.companies[i].id == id)
                        return this.companies[i]
                }
            },
            onValidate() {

                if (this.output.iso == undefined) {
   
                    return;
                }

                let norm = this.findNorm(this.output.iso)
                if (norm == undefined) {
     
                    return;
                }

                let company = this.findCompany(this.output.company)
                if (company == undefined) {
           
                    return;
                }
                this.output.companyName= company.name;
                this.output.name = norm.name;
                this.output.type = "iso";
                this.output.image = company.images[this.output.iso];
             
                this.$emit("validate", this.output)
            },

            onFileChange() {

       

                this.isLoading = true;

                this.filelist = [...this.$refs['dropzone-file-document'].files];
     
                if (this.filelist.length > 0) {
                    // this.SetLoadingMyLots(true)
                    // this.$emit("showList", false);
              
                    const formData = new FormData();
                    formData.append("image", this.filelist[0]); // appending file
                    // sending file to the backend
                    // "https://mdw-pvalette.vercel.app/api/lots/upload"
                    // "http://localhost:3000/api/lots/upload"

                    axios
                        .post("/api/images/upload", formData, {
                            headers: { "content-type": "multipart/form-data" },
                        })
                        .then((res) => {
                   
                            this.output.document = res.data
                     

                            this.filelist = [];

                            // this.$refs.form.reset();

                    
                            //this.SetLoadingMyLots(false)
                            this.isLoading = false;
                            // this.displayModal(false)
                            //  this.showModal2 = !this.showModal2;
                        })
                        .catch((err) => {
                    
                            console.log("ERROR =========================", err);
                        });
                }
            },

        },
    }
</script>